/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteReportOptionsViewModel
 */
export interface QuoteReportOptionsViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportOptionsViewModel
     */
    percentageOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportOptionsViewModel
     */
    includeBreakdownOfAnnualFees: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportOptionsViewModel
     */
    includeExposure: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteReportOptionsViewModel
     */
    includeComplaintsSection: boolean;
}

/**
 * Check if a given object implements the QuoteReportOptionsViewModel interface.
 */
export function instanceOfQuoteReportOptionsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "percentageOnly" in value;
    isInstance = isInstance && "includeBreakdownOfAnnualFees" in value;
    isInstance = isInstance && "includeExposure" in value;
    isInstance = isInstance && "includeComplaintsSection" in value;

    return isInstance;
}

export function QuoteReportOptionsViewModelFromJSON(json: any): QuoteReportOptionsViewModel {
    return QuoteReportOptionsViewModelFromJSONTyped(json, false);
}

export function QuoteReportOptionsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteReportOptionsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentageOnly': json['PercentageOnly'],
        'includeBreakdownOfAnnualFees': json['IncludeBreakdownOfAnnualFees'],
        'includeExposure': json['IncludeExposure'],
        'includeComplaintsSection': json['IncludeComplaintsSection'],
    };
}

export function QuoteReportOptionsViewModelToJSON(value?: QuoteReportOptionsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PercentageOnly': value.percentageOnly,
        'IncludeBreakdownOfAnnualFees': value.includeBreakdownOfAnnualFees,
        'IncludeExposure': value.includeExposure,
        'IncludeComplaintsSection': value.includeComplaintsSection,
    };
}

